/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Media_TemplateInputs */

const cs_social_export_media_template = /** @type {(inputs: Social_Export_Media_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plakát nemovitosti`)
};

const en_social_export_media_template = /** @type {(inputs: Social_Export_Media_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property poster`)
};

/**
* | output |
* | --- |
* | "Property poster" |
*
* @param {Social_Export_Media_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_media_template = /** @type {((inputs?: Social_Export_Media_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Media_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_media_template(inputs)
	return cs_social_export_media_template(inputs)
});